define('viewmodels/tournaments/TournamentExcludedGameDialog',[
    'underscore',
    'bluebird',
    'viewmodels/modals/alerts/ChoiceAlert'
], function (_, Promise, ChoiceAlert) {

    function TournamentExcludedGameDialog(gameLauncher,
                                          dialog,
                                          getCmsField,
                                          maybeTournamentCampaign) {

        var self = this;

        function playerParticipatingSoon(tournamentCampaign) {
            var currentTournament = tournamentCampaign.currentTournament(),
                nextTournament = tournamentCampaign.nextTournament();

            return currentTournament &&
                   currentTournament.isParticipating() ||
                   nextTournament &&
                   tournamentCampaign.nextTournament().isParticipating();
        }

        function currentParticipatingOrNextTournament(tournamentCampaign) {
            var currentTournament = tournamentCampaign.currentTournament(),
                nextTournament = tournamentCampaign.nextTournament();

            if (
                currentTournament &&
                currentTournament.isParticipating()
            ) {
                return currentTournament;
            } else {
                return nextTournament;
            }
        }

        function getOption(tournament) {
            if (tournament.isSpecificGameTournament()) {
                return {
                    id: 'redirect',
                    text: getCmsField('game_excluded_suggestion').replacements({
                        gameName: tournament.specificGame().name
                    }),
                    button: 'grey-lighter'
                };
            }

            return {
                id: 'cancel',
                text: getCmsField('game_excluded_choose_another'),
                button: 'grey-lighter'
            };
        }

        self.showIfNeeded = function (game) {

            return new Promise(function (resolve, reject) {

                var choiceAlert,
                    tournamentCampaign = maybeTournamentCampaign(),
                    tournament;

                if (
                    !tournamentCampaign ||
                    !playerParticipatingSoon(tournamentCampaign)
                ) {
                    resolve();
                    return;
                }

                tournament = currentParticipatingOrNextTournament(tournamentCampaign);

                if (tournament.isGameIncluded(game.providerGameId())) {
                    resolve();
                    return;
                }

                choiceAlert = new ChoiceAlert(
                    dialog,
                    getCmsField('game_excluded_title'),
                    getCmsField('game_excluded_message'),
                    [
                        getOption(tournament),
                        {
                            id: 'continue',
                            text: getCmsField('game_excluded_continue').replacements({
                                gameName: game.name
                            }),
                            button: 'grey-lighter'
                        }
                    ]
                );

                choiceAlert.show().then(
                    function (resultValue) {

                        if (resultValue === 'cancel') {
                            reject(new Error('Cancelled'));
                            return;
                        }

                        if (resultValue === 'redirect') {
                            reject(new Error('Cancelled'));
                            gameLauncher.launch(tournament.specificGame());
                            return;
                        }

                        resolve();
                    },
                    reject
                );

            });

        };

    }

    return TournamentExcludedGameDialog;

});

